<section class="overview">
  <markant-platform-additional-org-data-form
    [form]="additionalOrgDataForm()"
    [mode]="'read'"
  />

  <markant-platform-upgrade-service-variants
    [form]="variantUpgradeForm()"
    [upgradeCandidates]="upgradeCandidates()"
    [mode]="'read'"
    [booking]="booking()"
    [organization]="organization()"
  />
</section>
